import { twMerge } from 'tailwind-merge';

import { Markdown } from '@scale/scaleui';

const TutorialMarkdown = ({ className, message }: { className?: string; message: string }) => {
  return (
    <Markdown
      className={twMerge(
        `w-full [&>pre]:w-[100%] [&_*]:!m-0 !p-0 [&_li]:leading-none [&_ul]:leading-none [&_p]:leading-snug`,
        className,
      )}
      markdown={message}
    />
  );
};

export default TutorialMarkdown;
